export interface ClientMandatoryFieldResponse {
    field_required: any;
    field_control_type: any;
}